export default "__VITE_ASSET__CdfTDBC9__"